export default __webpack_public_path__ + "static/media/logo.27bf01cb.png";